module.exports = __webpack_public_path__ + "media/images/logo-49fe9db9.png";